import { Injectable } from '@angular/core';
import { ProcedureEnum } from '@core/procedure-helpers/models/procedure.enum';
import { OrderQuery } from '@modules/order/state/order-query';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { Observable, combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ArchAlignmentQuery } from './arch-alignment.query';
import { ArchAlignmentState, ArchAlignmentStore } from './arch-alignment.store';

@Injectable()
export class ArchAlignmentFacade {
	readonly isVisible$: Observable<boolean> = this.orderQuery.procedureMap$.pipe(
		map(procedureMap => procedureMap?.ProcedureId === ProcedureEnum.InvisalignART),
		shareReplay({ bufferSize: 1, refCount: true })
	);

	readonly isReadOnly$: Observable<boolean> = combineLatest({
		isOrderReadOnly: this.shellQuery.getReadOnlyState('order'),
		isRxSent: this.shellQuery.isRxSent$
	}).pipe(map(({ isOrderReadOnly, isRxSent }) => isOrderReadOnly || isRxSent));

	get state(): ArchAlignmentState {
		return this.query.state;
	}

	constructor(
		private readonly store: ArchAlignmentStore,
		private readonly query: ArchAlignmentQuery,
		private readonly orderQuery: OrderQuery,
		private readonly shellQuery: ShellQuery
	) {}

	loadFromRx(): void {
		const archAlignment = this.shellQuery.rx?.ArchAlignment;

		this.updateArchAlignment({
			OnUpperJaw: archAlignment?.OnUpperJaw ?? true,
			OnLowerJaw: archAlignment?.OnLowerJaw ?? true
		});
	}

	updateArchAlignment(state: ArchAlignmentState): void {
		this.store.update(state);
	}
}
